import { createClientWithConsent } from 'components/newAccountSteps/profileSteps/services/createClientWithConsent';

require('sass/blocks/_joint-holders.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const Storage = require('utilities/storage');
const cryptoJS = require('crypto-js');
// @ utilities
import { formatText, FormattedText } from 'core/i18n';
const UtagHelper = require('utilities/utagHelper');
const {
    recordPage,
    recordEvent,
    recordCreateNewClient,
    errorTag,
    PAGE_PRODUCT,
    recordEventStepSuccess,
} = require('utilities/uTagging');
// @ components
const Headline = require('components/headline');
const JointHolderStatusCard = require('components/jointHolders/cardBox/jointHolderStatusCard');
const JointHolders = require('components/jointHolders/jointHolders').JointHolders;
// @ commons
const Accordion = require('components/commons/accordion/accordion');
const AccordionBody = require('components/commons/accordion/accordionBody/accordionBody');
const TitleBox = require('components/commons/titleBox/titleBox');
// @ constants
const { PUBLICA_URL } = require('constants/index');
const {
    ERROR_EN_STAND_BY_INTERMEDIO_AL_TRAER_DATOS_INTERV,
    ERROR_AL_VERIFICAR_FIOC,
} = require('constants/analyticsErrors');
const { PATH_STANDBY_JOINHOLDER, PATH_PROFESSION } = require('constants/uTagConstants/paths');
// @ actions
const formActions = require('react-redux-form').actions;
const jointHoldersStatusActions = require('actions/jointHoldersStatusActions');
const stepsActions = require('actions/stepsActions');
const preLoaderActions = require('actions/preLoaderActions');
const createActions = require('actions/createActions');
import { stopPolling } from 'actions/polling';
import consentsActions from 'actions/consentsActions';
// @ icons
const creditCardIcon = require('assets/icons/headline/icono_tarjeta2.svg');

class StandByHC extends React.Component {
    constructor(props) {
        super(props);

        this.handleUnderstood = this.handleUnderstood.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { userProfile, jointHoldersStatusActions, immJointHoldersStatus } = this.props;
        const accessToken = userProfile.accessToken;

        if (!immJointHoldersStatus.get('fetchSuccess')) {
            jointHoldersStatusActions.statusHolders(accessToken);
        }
    }

    componentDidMount() {
        const { userProfile, products, immJointHoldersStatus } = this.props;
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
        const error = immJointHoldersStatus.error;
        recordPage(
            PATH_STANDBY_JOINHOLDER,
            userProfile.recordId,
            userProfile.userId,
            userProfile.product,
            products.get('productsDescription'),
            userProfile.promoCode ? userProfile.promoCode : '',
            JointHolderInfo,
            '',
            '',
            userProfile.investmentType,
            {
                identificadorOnboarding: docNumberEncrypted,
            }
        );
        if (error) {
            errorTag(
                error.body,
                PATH_STANDBY_JOINHOLDER,
                ERROR_EN_STAND_BY_INTERMEDIO_AL_TRAER_DATOS_INTERV,
                error.statusCode
            );
        }
    }

    componentWillUnmount() {
        stopPolling();
    }

    handleUnderstood() {
        const { userProfile } = this.props;
        const { investmentType, docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        recordEvent(
            PATH_STANDBY_JOINHOLDER,
            PAGE_PRODUCT,
            'standby datos intervinientes',
            'entendido',
            '',
            '',
            '',
            investmentType,
            docNumberEncrypted
        );
        if (Storage.cookies.get('accessToken')) {
            Storage.cookies.remove('accessToken');
        }
        if (Storage.cookies.get('refreshToken')) {
            Storage.cookies.remove('refreshToken');
        }
        window.location.href = PUBLICA_URL;
    }

    getCardBoxes() {
        const { immJointHoldersStatus } = this.props;

        return immJointHoldersStatus.get('byOrder').map((holderId, index) => {
            const immJointHolder = immJointHoldersStatus.getIn(['byId', holderId.toString()]);

            return (
                <JointHolderStatusCard
                    key={index}
                    immJointHolder={immJointHolder}
                    batchStatus={immJointHoldersStatus.get('batchStatus')}
                />
            );
        });
    }

    getSubtitleHC() {
        const { immJointHoldersStatus } = this.props;
        const statusBatch = immJointHoldersStatus.get('batchStatus');
        const subtitle = !statusBatch ? formatText('standByHC-subtitle') : formatText('standByHC-batchSubtitle');
        let subtitleBox;

        if (!statusBatch) {
            subtitleBox = (
                <Headline icon="standByHC" className="prospects-gutter prospects-standBy">
                    <p>{subtitle}</p>
                </Headline>
            );
        } else {
            subtitleBox = (
                <div className="batch prospects-gutter">
                    <div className="batch__message batch__yellow-box">
                        <i className="batch__message__icons icons--icon-alert-yellow"></i>
                        <p className="font-paragraph2">{subtitle}</p>
                    </div>
                </div>
            );
        }

        return subtitleBox;
    }

    getJointHolderCards() {
        const { userProfile } = this.props;
        const cardStatement = this.getCardStatement();

        if (userProfile.isJointHolder) {
            return (
                <div>
                    <Accordion id="holders" title={formatText('jointHolderStatus-title')}>
                        <AccordionBody name="AccordionBody">
                            <div className="jointholders">
                                <div className="box-container">{this.getCardBoxes()}</div>
                            </div>
                        </AccordionBody>
                    </Accordion>
                </div>
            );
        }

        return (
            <div>
                <Accordion id="holders" title={formatText('jointHolderStatus-title')}>
                    <AccordionBody name="AccordionBody">
                        <JointHolders limit={4} />
                    </AccordionBody>
                </Accordion>
                {cardStatement}
            </div>
        );
    }

    getCardStatement() {
        const { immJointHoldersStatus } = this.props;
        let cardStatement;

        immJointHoldersStatus.get('byOrder').map(holderId => {
            const immJointHolder = immJointHoldersStatus.getIn(['byId', holderId.toString()]);

            if (immJointHolder.get('checkOpenCredit')) {
                cardStatement = (
                    <div className="card-info__aclaration clearfix">
                        <img src={creditCardIcon} alt="" className="card-info__icon" />
                        <FormattedText value="cardInfo-standByFinalInfo" />
                    </div>
                );

                return;
            }
        });

        return cardStatement;
    }

    handleContinue() {
        const { userProfile, actions, createActions, immStepsState, preLoaderActions, formActions, consentsActions } =
            this.props;
        const { docNumber, promoCode, investmentType, product, recordId } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const accessToken = userProfile.accessToken;
        const currentIndex = immStepsState.get('currentStep');
        const jointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

        if (userProfile.status === 'waiting') {
            preLoaderActions.setInformationText(formatText('informationText-fioc'));
            preLoaderActions.showPreLoader();
            actions.clientFiocVerify(accessToken, (verified, data) => {
                if (verified) {
                    const finishAction = () => {
                        actions.finalizeStep({
                            index: currentIndex,
                            finished: true,
                        });

                        actions.enableFinishedAndNextStep();
                        formActions.change('userProfile.status', 'created');
                        formActions.change('userProfile.jointHolderDecision', 'false');
                        actions.changeCurrentStep({
                            index: currentIndex + 1,
                        });
                        preLoaderActions.hidePreLoader();
                    };
                    const onCreateClient = userId => {
                        recordEvent(
                            PATH_STANDBY_JOINHOLDER,
                            PAGE_PRODUCT,
                            'tu actividad',
                            'tu actividad correcto',
                            recordId,
                            userId,
                            '',
                            investmentType ? investmentType : '',
                            docNumberEncrypted
                        );
                        recordEventStepSuccess(investmentType, '/onboarding/tu-actividad/', 'tu actividad');
                        recordCreateNewClient(
                            recordId,
                            userId,
                            product,
                            promoCode ? promoCode : '',
                            '',
                            '',
                            investmentType ? investmentType : '',
                            jointHolderInfo
                        );
                    };
                    createClientWithConsent(
                        { createActions, consentsActions },
                        accessToken,
                        onCreateClient,
                        finishAction
                    );
                } else {
                    errorTag(data, PATH_PROFESSION, ERROR_AL_VERIFICAR_FIOC, '');
                    preLoaderActions.hidePreLoader();
                }
            });
        } else {
            this.props.actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }
    }

    buildButton() {
        const { userProfile } = this.props;
        const cant = userProfile.jointHolderCount ? Object.keys(userProfile.jointHolderCount).length : 0;

        if (cant === 0 && !userProfile.isJointHolder) {
            return (
                <div className="form__buttons form__footer">
                    <button type="button" className="form__button form__button-primary" onClick={this.handleContinue}>
                        <FormattedText value="button-continueHC" />
                    </button>
                </div>
            );
        }

        return (
            <div className="form__buttons form__footer">
                <button type="button" className="form__button form__button-secondary" onClick={this.handleUnderstood}>
                    <FormattedText value="button-understood" />
                </button>
            </div>
        );
    }

    render() {
        const { userProfile, immJointHoldersStatus } = this.props;
        const name = userProfile.name;
        const statusBatch = immJointHoldersStatus.get('batchStatus');
        const title = statusBatch ? formatText('standByHC-batchTitle', [name]) : formatText('standByHC-title', [name]);
        const subtitleBox = this.getSubtitleHC();
        const jointHoldersCards = this.getJointHolderCards();
        const button = this.buildButton();

        return (
            <div className="joint-holder__standby-hc">
                <TitleBox title={title} titleModifier="--stand-by" dash="dash" />
                {subtitleBox}
                <div className="prospects-gutter prospects-separator accordion-container">{jointHoldersCards}</div>
                <div className="joint-holder__standby-hc-gutter">
                    <FormattedText value="standByHC-footer" />
                </div>
                {button}
            </div>
        );
    }
}

module.exports.constructor = StandByHC;
module.exports.StandByHC = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immJointHoldersStatus: state.jointHoldersStatus,
        products: state.products,
        immStepsState: state.steps,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        jointHoldersStatusActions: bindActionCreators(jointHoldersStatusActions, dispatch),
        actions: bindActionCreators(stepsActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        createActions: bindActionCreators(createActions, dispatch),
        consentsActions: bindActionCreators(consentsActions, dispatch),
    })
)(StandByHC);
